import * as React from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';

// Component
function ContentOrnament(props: any) {
    return (
        <>
            <img alt="top corner content ornament" style={{ position: "absolute", width: "78px", left: "-13px", top: "-17px" }} src="Top Corner_Ornament_DragonHead.png" />
            <img alt="top corner content ornament" style={{ position: "absolute", width: "78px", right: "-13px", top: "-17px", transform: "scale(-1, 1)" }} src="Top Corner_Ornament_DragonHead.png" />

            <img alt="bottom corner content ornament" style={{ position: "absolute", width: "78px", left: "-13px", bottom: "-35px" }} src="Bottom Corner_Ornament_DragonHead.png" />
            <img alt="bottom corner content ornament" style={{ position: "absolute", width: "78px", right: "-13px", bottom: "-35px", transform: "scale(-1, 1)" }} src="Bottom Corner_Ornament_DragonHead.png" />


            <Box style={{ position: "absolute", top: "0px", left: 0, padding: "0 65px", width: "100%", height: "4px", background: "" }}>
                <Box style={{ position: "relative" }}>
                    <img alt="dragon ornament h line" style={{ height: "6px", position: "absolute", width: "100%", left: 0 }} src="Ornament_repeating_line.png" />
                </Box>
            </Box>

            <Box style={{ position: "absolute", bottom: "-4px", left: 0, padding: "0 65px", width: "100%", height: "4px", background: "" }}>
                <Box style={{ position: "relative" }}>
                    <img alt="dragon ornament h line" style={{ height: "6px", position: "absolute", width: "100%", left: 0 }} src="Ornament_repeating_line.png" />
                </Box>
            </Box>

            <Box style={{ position: "absolute", width: "3px", background: "", height: "100%", left: -10, padding: "24px 0px 53px 0px" }}>
                <Box style={{ background: "#484544", height: "100%", width: "100%" }}></Box>
            </Box>

            <Box style={{ position: "absolute", width: "3px", background: "", height: "100%", right: -10, padding: "24px 0px 53px 0px" }}>
                <Box style={{ background: "#484544", height: "100%", width: "100%" }}></Box>
            </Box>
        </>
    )
}

// Export
export default ContentOrnament;
